<div class="slider-tooltip" (click)="$event.stopPropagation()">
  <input class="range" type="range" min="0" max="1" step="0.01" [value]="value" (input)="onChange($event)" />
  <span>{{ visibleValue }}%</span>
</div>
